import { cells } from './cells';
import { Table as BaseTable } from './Table';
export * from './cells/types';
export var Table = Object.assign(BaseTable, cells);
//# sourceMappingURL=index.js.map